
function guid() {
    let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
    for (let i = 0, len = chars.length; i < len; i++) {
        switch (chars[i]) {
            case "x":
                chars[i] = Math.floor(Math.random() * 16).toString(16);
                break;
            case "y":
                chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
                break;
        }
    }
    return chars.join("");
}

function extend(target, parent) {
    function inherit(prototype) {
        if (Object.create) {
            return Object.create(prototype);
        }

        function f() { }
        f.prototype = prototype;
        return new f();
    }
    target.prototype = inherit(parent.prototype);
    target.prototype.constructor = target;
}

function Observer() {
    this.callbacks = [];
}
Observer.prototype.notify = function () {
    this.callbacks.map(x => x());
};
Observer.prototype.remove = function (f) {
    this.callbacks = this.callbacks.filter(x => x != f);
};
Observer.prototype.add = function (f) {
    this.callbacks.push(f);
};

function Page(id = null, title = "") {
    this.id = id;
    this.title = title;
    this.isInitialized = false;
}
Page.prototype._onInitialize = function () {
    let self = this;
    setTimeout(() => {
        self._initialized();
    }, 1000);
};
Page.prototype.initialize = function () {
    this._onInitialize();
};
Page.prototype._onDestroy = function () { };
Page.prototype.destroy = function () {
    this._onDestroy();
};

function Site(title = "TackleBox", logo = "") {
    this.title = title;
    this.logo = logo;
}

function Auth(username = "", logo = "") {
    this.username = username;
    this.logo = logo;
}

function Pager(site = new Site(), page = new Page(), auth = new Auth()) {
    this.site = site;
    this.page = page;
    this.auth = auth;
}
Pager.prototype.getPageId = function () {
    return this.page.id;
};
Pager.prototype.getPageTitle = function () {
    return this.page.title;
}
Pager.prototype.changePage = function (page) {
    this.page.destroy();
    this.page = page;
    this.page.initialize();
};
Pager.prototype.exitPage = function () {
    this.page.destroy();
    this.page = new Page();
};
Pager.prototype.logout = function () {

};
Pager.prototype.login = function () {

};
Pager.prototype.destroy = function () {
    this.page.destroy();

};


export { guid, extend, Observer, Page, Pager, Site, Auth };